module.exports = __webpack_public_path__ + "img/Meermansboot.39c53f28.svg";